/**
 * NAT Parts
 */

export default {
  CONDITION: 'condition',
  TRANSLATION: 'translation',
};
